<div class="row">
  <div class="col-12">
    <h2 class="mb-4 text-md-left text-center">{{ 'habaCatalogForm.heading' | cxTranslate }}</h2>

    <form [formGroup]="catalogOrderForm">
      <div class="form-row">
        <div class="col-6 col-md-4">
          <ng-container *ngIf="titles$ | async as titles">
            <div *ngIf="titles.length !== 0">
              <app-form-select>
                <app-form-label>{{
                  'habaCatalogForm.form.title.label' | cxTranslate
                }}</app-form-label>
                <ng-select
                  formControlName="titleCode"
                  [searchable]="false"
                  [clearable]="false"
                  [items]="titles"
                  bindLabel="name"
                >
                  <ng-template ng-option-tmp let-item="item">
                    {{ item.name | cxTranslate }}
                  </ng-template>

                  <ng-template ng-label-tmp let-item="item">
                    {{ item.name | cxTranslate }}
                  </ng-template>
                </ng-select>
                <app-form-error>{{
                  'habaCatalogForm.form.title.error' | cxTranslate
                }}</app-form-error>
              </app-form-select>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="form-row">
        <div class="col-6">
          <app-form-input>
            <app-form-label>{{
              'habaCatalogForm.form.firstName.label' | cxTranslate
            }}</app-form-label>
            <input appFormInput type="text" formControlName="firstName" />
            <app-form-error>{{
              'habaCatalogForm.form.firstName.error' | cxTranslate
            }}</app-form-error>
          </app-form-input>
        </div>
        <div class="col-6">
          <app-form-input>
            <app-form-label>{{
              'habaCatalogForm.form.lastName.label' | cxTranslate
            }}</app-form-label>
            <input appFormInput type="text" formControlName="lastName" />
            <app-form-error>{{
              'habaCatalogForm.form.lastName.error' | cxTranslate
            }}</app-form-error>
          </app-form-input>
        </div>
      </div>

      <div class="form-row">
        <div class="col col-md-6">
          <app-form-input [floatLabel]="true">
            <app-form-label>{{
              'habaCatalogForm.form.birthdate.label' | cxTranslate
            }}</app-form-label>
            <input
              placeholder="adf"
              appFormInput
              type="date"
              formControlName="birthdate"
              class="not-empty"
            />
          </app-form-input>
        </div>
      </div>

      <div class="form-row">
        <div class="col-8 col-md-4">
          <app-form-input>
            <app-form-label>{{
              'habaCatalogForm.form.address1.label' | cxTranslate
            }}</app-form-label>
            <input appFormInput type="text" formControlName="street" />
            <app-form-error>{{
              'habaCatalogForm.form.address1.error' | cxTranslate
            }}</app-form-error>
          </app-form-input>
        </div>
        <div class="col-4 col-md-2">
          <app-form-input>
            <app-form-label>{{ 'habaCatalogForm.form.nr.label' | cxTranslate }}</app-form-label>
            <input appFormInput type="text" formControlName="houseNumber" />
            <app-form-error>{{ 'habaCatalogForm.form.nr.error' | cxTranslate }}</app-form-error>
          </app-form-input>
        </div>
      </div>

      <div class="form-row">
        <div class="col-4">
          <app-form-input>
            <app-form-label>{{
              'habaCatalogForm.form.zipCode.label' | cxTranslate
            }}</app-form-label>
            <input appFormInput type="text" formControlName="postalCode" />
            <app-form-error>{{
              'habaCatalogForm.form.zipCode.error' | cxTranslate
            }}</app-form-error>
          </app-form-input>
        </div>
        <div class="col-8">
          <app-form-input>
            <app-form-label>{{ 'habaCatalogForm.form.city.label' | cxTranslate }}</app-form-label>
            <input appFormInput type="text" formControlName="town" />
            <app-form-error>{{ 'habaCatalogForm.form.city.error' | cxTranslate }}</app-form-error>
          </app-form-input>
        </div>
      </div>

      <div class="form-row">
        <div class="col-12">
          <app-form-input>
            <app-form-label>{{
              'habaCatalogForm.form.country.label' | cxTranslate
            }}</app-form-label>
            <input appFormInput type="text" formControlName="country" readonly="readonly" />
            <app-form-error>{{
              'habaCatalogForm.form.country.error' | cxTranslate
            }}</app-form-error>
          </app-form-input>
        </div>
      </div>

      <div class="form-row">
        <div class="col-12">
          <app-form-input>
            <app-form-label>{{ 'habaCatalogForm.form.email.label' | cxTranslate }}</app-form-label>
            <input appFormInput type="email" formControlName="email" />
            <app-form-error>{{ 'habaCatalogForm.form.email.error' | cxTranslate }}</app-form-error>
          </app-form-input>
        </div>
      </div>

      <div class="form-row">
        <div class="col-6">
          <div class="button-wrapper">
            <button type="submit" class="btn btn-full btn-primary">
              {{ 'habaCatalogForm.form.submit' | cxTranslate }}
            </button>
          </div>
        </div>
      </div>
    </form>

    <hr class="my-4" />
  </div>
</div>
